import i18next from 'i18next';

i18next.addResources('es', 'searchButton', {
  search: 'Buscar'
});

i18next.addResources('en', 'searchButton', {
  search: 'Search'
});

i18next.addResources('pt', 'searchButton', {
  search: 'Buscar'
});
